/**
 * Default appointment-status colours (the schedule's left status bar,
 * Dentrix style; @velora/contracts/apptStatus). Each office can change them
 * in Settings > Appointment statuses, so they are plain #RRGGBB data, one
 * value for both themes like Dentrix's own status colours, and every one
 * reads on the dark and the light card fills. Owner rules: Here a light
 * brand-orange tint (was yellow; no yellow or gold, role test FD-21),
 * Ready / Seated green, Confirmed dark green, Left message orange, not
 * confirmed grey, Emergency red, and no blue or yellow / gold anywhere.
 *
 * TODO(owner): Here is undecided. The scheduler role test (2026-10-20) set it
 * to pink (#ec407a) and the front-desk role test (FD-21) to light orange
 * (#fdb57e); r7 ships the light orange. The owner may want the original
 * yellow back; change `here` here and in the --signal-here flow token.
 */
export const APPT_STATUS_COLORS = {
  unconfirmed: '#9aa0a6',
  confirmed: '#2e7d32',
  sent: '#a1887f',
  message: '#f57c00',
  unreachable: '#8d6e63',
  emergency: '#d32f2f',
  here: '#fdb57e',
  ready: '#43a047',
  chair: '#43a047',
  checkout: '#a0528c',
  other: '#a1887f',
} as const;

/** Abbreviations whose default differs from their kind's (Dental Intel confirmations). */
export const APPT_STATUS_ABBR_COLORS: Readonly<Record<string, string>> = {
  DICONF: '#558b2f',
};
